import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { whiteboardCreated } from 'features/layout/features/content/actions';
import { SHARED_FOLDER_ID } from 'features/content-library/constants';

export function* createWhiteboardSaga(action: ReturnType<typeof whiteboardCreated>) {
  const { folderId } = action.payload;

  yield call(SignalingSocket.send, {
    event: 'createWhiteboard',
    data: {
      ...action.payload,
      folderId: folderId === SHARED_FOLDER_ID ? undefined : folderId,
    },
  });
}
